<template>
  <div class="NewsShow">
    <div style="width: 980px;margin: auto;">
      <div class="title-box" v-html="title"></div>
      <!--      <el-button type="success" @click="admit">提交</el-button>-->
      <div class="date-box">发布时间：{{date}}</div>
      <div class="date-box">截止时间：{{endTime}}</div>
      <div v-html="content" class="details-box" ></div>
      <div>
        <el-form-item  label="评论结果：">
          <el-radio-group v-model="result">
            <el-radio :label="1">赞同</el-radio>
            <el-radio :label="2">反对</el-radio>
            <el-radio :label="3">不确定</el-radio>
          </el-radio-group>
<!--          <el-col>-->
<!--            <el-input  v-model="result" placeholder="请输入结果（1:赞同 2:反对 3:不确定）" clearable />-->
<!--          </el-col>-->
        </el-form-item>
      </div>

      <div>
        <ckeditor :editor="editor"  v-model="myContent" :config="editorConfig" :class="ck-editor__editable"></ckeditor>
        <el-button type="success" @click="admit">提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import time from "@/core/time";
import {ElLoading} from "element-plus";
export default {
  created() {
  },
  mounted() {
    this.id = this.$route.query.id;
    this.filter();

  },
  data() {
    return {
      endTime:'',
      result:'',
      title:'',
      content:'',
      myContent:'',
      collectId:'',
      userId:'',
      id:'',
      input:'',
      editor: ClassicEditor,
      editorConfig: {
        min_height: 800,
        // The configuration of the editor.
        toolbar: ['heading', '|', 'bold', 'italic', 'alignment', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'outdent', 'indent' , '|', 'uploadImage', 'mediaEmbed','insertTable','|', 'undo', 'redo'],
        simpleUpload: {
          uploadUrl: '/api3/config/fileInfo/uploadImg',
          withCredentials: false,
        },
        mediaEmbed: {   // 视频配置
          previewsInData: true,
          providers: [
            {
              name: 'myprovider',
              url: [
                /^lizzy.*\.com.*\/media\/(\w+)/,
                /^www\.lizzy.*/,
                /(http|https):\/\/([\w.]+\/?)\S*/
              ],
              html: match => {
                //获取媒体url
                const input = match['input'];
                return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 70%;">' +
                    // 'video controls="controls" autoplay name="media" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"'+
                    // `source src="${input}" type="video/mp4"`+
                    // '/video'+
                    `<iframe src="${input}" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" allowtransparency="true" allow="encrypted-media">' +
                    '</iframe>' +
                    '</div>'
                );
              }
            }
          ]
        }
      },
      editorData: '',


      totalNum: 0, pageNum: 1, pageSize: 6,
      news: [],
    }
  },
  methods:{
    admit() {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() +1;
      let day = new Date().getDate();
      let time = year + '-' + month + '-' + day;
      if(this.endTime<time){
        this.$msg.warning('已超出截止时间！')
      }else {
        if(this.result==''&&this.myContent==''){
          this.$msg.warning('请输入评论结果和内容')
        }else if(this.result==''&&this.myContent!=''){
          this.$msg.warning('请输入评论结果')
        }else if(this.result!=''&&this.myContent==''){
          this.$msg.warning('请输入评论内容')
        }else{
          let data ={
            id:this.id,
            result:this.result,
            myContent:this.myContent,
            collectId:this.id,
            userId:this.$store.getters.userId
          }
          let url = '/ArAssess/insertMyAssess'
          this.$request.post(url,data).then(res=>{
            console.log(res)
          })
          this.$msg.success('提交成功')
          this.$router.push({
            path: '/fassessList',
            query: {
              id: this.id,
            }
          })
        }
      }


    },
    filter(){
      let data = this.id;
      let loadingInstance = null;
      loadingInstance = ElLoading.service({ fullscreen: true});
      this.$request.post('/ArAssess/selectAssess',data).then(data => {
        console.log(data);
         this.title =  data.obj.assess.title;
         this.content = data.obj.assess.content;
        this.endTime = time.formateDate(data.obj.assess.endTime);
        this.date = time.formateDate(data.obj.assess.createdDate);
        loadingInstance.close();
      })
    },
  }
}
</script>

<style lang="less">
.ck-editor__editable {
  min-height: 500px;
  word-break:break-all;
}
.NewsShow{
  width: 100%;
  height: 100%;
  a:link {color: black; text-decoration:none;} //未访问
  a:active {color: black; } //激活：红色
  a:visited {color:black;text-decoration:none;} //已访问
  a:hover {color: black; text-decoration:underline;} //鼠标移近
  .btn-back{
    border: none;
    font-size: 16px;
  }
  .title-box{
    text-align: center;
    font-size: 20px;
    margin: 60px 0 30px 0;
    font-weight: 800;
  }
  .date-box{
    font-size: 16px;
    color: #777777;
    text-align: center;
    padding-bottom: 48px;
  }
  .details-box{
    margin-top: 25px;
    font-size: 16px;
    line-height: 25px;
    text-align: left;
    img{
      align:center;
      max-width: 100%;
      max-height: 700px;
    }

  }
  .file-box{
    margin-top: 40px;
    padding-bottom: 50px;
  }
}
</style>